import { render, staticRenderFns } from "./main-information-slide.vue?vue&type=template&id=234a1cf6&scoped=true"
import script from "./main-information-slide.vue?vue&type=script&lang=js"
export * from "./main-information-slide.vue?vue&type=script&lang=js"
import style0 from "./main-information-slide.vue?vue&type=style&index=0&id=234a1cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a1cf6",
  null
  
)

export default component.exports